"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authDefaults = {
  host: "https://connect.lonelyplanet.com",
  options: {
    clientId: "foymu5r6sscxe",
    scope: ["openid"]
  }
};


//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-core/dist/constants/index.js
// module id = RF4c
// module chunks = 2